import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { redirectFromLogin as _redirectFromLogin } from '../redux/actions/authActions';
import FullPageSpinner from '../components/common/FullPageSpinner/FullPageSpinner';
import path from '../helpers/path';
function withAuthentication(WrappedComponent) {
  var ModifiedComponent = function ModifiedComponent(props) {
    var isAuthenticated = props.isAuthenticated,
      location = props.location,
      pendingAuth = props.pendingAuth,
      redirectFromLogin = props.redirectFromLogin;
    if (pendingAuth) {
      return React.createElement(FullPageSpinner, null);
    }
    if (!isAuthenticated) {
      redirectFromLogin(location);
      return React.createElement(Redirect, {
        to: path('/login')
      });
    }
    return React.createElement(WrappedComponent, props);
  };
  var mapStateToProps = function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      pendingAuth: state.auth.pending
    };
  };
  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      redirectFromLogin: function redirectFromLogin(location) {
        return dispatch(_redirectFromLogin(location));
      }
    };
  };
  return connect(mapStateToProps, mapDispatchToProps)(ModifiedComponent);
}
export default withAuthentication;